import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled(m.figure) `
  text-align: center;
  `;
const Image = styled(SimpleImage) `
  ${({ maxHeight }) => maxHeight &&
    css `
      max-height: ${maxHeight}px;
    `}

    ${({ size }) => size &&
    css `
      width: calc(100% * ${size});
    `}
`;
const Caption = styled.figcaption ``;
const ImageBlockStyles = {
    Caption,
    Container,
    Image,
};
export default ImageBlockStyles;
